import React, { useState } from 'react';
import {  Typography } from "@material-ui/core";
import {
    Loader,
    objestados,
    usuario_habilitado_sede,
    deshabilitar
} from './index.js';

import { useAscenso } from '../../hooks/useAscenso.js';
import { Spinner } from '@material-tailwind/react';
import Main from '../../../../componentes/Main.js';


import { Acta } from '../modulos/componentes/Acta';
import { FechaActa } from '../modulos/componentes/FechaActa';
import { Botones } from '../modulos/componentes/Botones';
import { PanelDatosGenerales } from '../modulos/componentes/PanelDatosGenerales';
import { PanelEntrevista } from '../modulos/componentes/PanelEntrevista';
import { PanelAdjuntos } from '../modulos/componentes/PanelAdjuntos';
import { ValidacionesCheckboxes } from '../modulos/componentes/ValidacionesCheckboxes';
import { PanelAdjuntosDinamico } from '../modulos/componentes/PanelAdjuntosDinamico.js';

export const TR_AscensoNew = ({ id, cabecera, setData, usuario, snackbar, puedeEditarse, cambiarStatus,finalizar }) => {

    const {
        error, loading, loading2, procesando, datosDelTramite, status_actual_tramite,
        acta_regional, setActa_regional, fechaAR, handleChangeFechaAR, setActa_cdn, fechaACDN,
        handleChangeFechaACDN, inicioActualizacionTramite, actualizarTramite, touched, refrescar,
        acta_cdn, refrescando, traerUrl, accederEntrevista, IniciarCerrarEntrevista,
        analitico, handleChangeAnaliticoCheck, nuevoAnalitico, setNuevoAnalitico,
        cambiarAnalitico, setCambiarAnalitico, nuevoExtra1, setNuevoExtra1,
        cambiarExtra1, setCambiarExtra1, linkEntrevista
    } = useAscenso(cabecera, id, setData, usuario, snackbar);

    const [activeTab, setActiveTab] = useState('informacion_general');

    const sinCambiosPendientes = () => {
        return !(cambiarAnalitico && !nuevoAnalitico) && !(cambiarExtra1 && !nuevoExtra1);
    };

    if (error) return <div className="p-4 bg-red-50 text-red-700 rounded-lg"><p>{JSON.stringify(error)}</p></div>;
    
    if (loading || loading2 || procesando) {
        return (
            <Main center alinear>
                <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)] gap-3'>
                    <Spinner className="h-12 w-12 text-blue-500" />
                    <span className="font-semibold text-gray-600 text-sm">Cargando...</span>
                </div>
            </Main>
        );
    }
    
    if (!datosDelTramite) return <div className="p-8 text-center"><Spinner className="h-12 w-12 mx-auto text-blue-500" /><p className="text-gray-500 mt-2">Cargando solicitud...</p></div>;

    return (
        <div id="solicitud-proceso" className="w-full mx-auto space-y-4 antialiased text-gray-800">
            <Loader open={refrescando} />
            <div className="flex flex-col col-span-1 lg:col-span-7 bg-gray-50 border border-gray-200 rounded-md p-2  shadow-sm overflow-y-auto max-h-[500px]">
                <ValidacionesCheckboxes 
                    estadoOcultoOConsolidado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                    campo_check={analitico}
                    label_checked="Analítico confirmado"
                    label_unchecked_no_autorizado="Confirmación de analítico pendiente"
                    label_unchecked_autorizado="El analítico es válido"
                    handleChange={handleChangeAnaliticoCheck}
                />
                <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-1">
                        <div className="flex flex-row flex-wrap gap-4 border border-gray-300 rounded-md bg-white p-3">
                                <Acta 
                                    estadoOcultoOConsolidado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                    setActa={setActa_regional}
                                    acta={acta_regional}
                                    titulo="Número Acta Regional"
                                />
                                <FechaActa
                                    estadoOcultoOConsolidado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                        handleChangeFecha={handleChangeFechaAR}
                                        fecha={fechaAR}
                                        titulo="Fecha Acta Regional"
                                />                              
                                <Acta 
                                    estadoOcultoOConsolidado={deshabilitar(status_actual_tramite, [objestados.procSede.nombre], 'no_encontrado') || !usuario_habilitado_sede(usuario)}
                                    setActa={setActa_cdn}
                                    acta={acta_cdn}
                                    titulo="Número Acta CDN"
                                />       
                                <FechaActa
                                    estadoOcultoOConsolidado={deshabilitar(status_actual_tramite, [objestados.procSede.nombre], 'no_encontrado') || !usuario_habilitado_sede(usuario)}
                                        handleChangeFecha={handleChangeFechaACDN}
                                        fecha={fechaACDN}
                                        titulo="Fecha Acta CDN"
                                />                         
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full text-left items-start antialiased">
                    
                    <PanelDatosGenerales
                        datosDelTramite={datosDelTramite} 
                        atributos={[{valor:datosDelTramite.ministro,descripcion:'Nombre del ministro'},
                                    {valor:datosDelTramite.status_actual,descripcion:'Rango actual'}]}
                    />

                    {/* <PanelAdjuntos
                        usuario={usuario}
                        status_actual_tramite={status_actual_tramite}
                        datosDelTramite={datosDelTramite}
                        cambiarAnalitico={cambiarAnalitico}
                        nuevoAnalitico={nuevoAnalitico}
                        cambiarExtra1={cambiarExtra1}
                        nuevoExtra1={nuevoExtra1}
                        traerUrl={traerUrl}
                        setCambiarAnalitico={setCambiarAnalitico}
                        setCambiarExtra1={setCambiarExtra1}
                        setNuevoAnalitico={setNuevoAnalitico}
                        setNuevoExtra1={setNuevoExtra1}
                    />     */}


                <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm space-y-4 h-full">
                    <Typography variant="small" color="blue-gray" className="font-bold uppercase tracking-wider text-xs border-b border-gray-200 pb-2 text-slate-500">
                        Archivos adjuntos
                    </Typography>

                    {(deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region') && (
                        <p className="text-[11px] text-red-600 bg-red-50 p-2.5 rounded-lg border border-red-100 leading-normal font-medium">
                            Cambios permitidos solo para Secretarios Regionales en estado "En proceso regional".
                        </p>
                    )}

                    <PanelAdjuntosDinamico 
                        titulo="Analítico"
                        url={datosDelTramite?.analiticoURL}
                        editando={cambiarAnalitico}
                        nuevoArchivo={nuevoAnalitico}
                        setEditando={setCambiarAnalitico}
                        setNuevoArchivo={setNuevoAnalitico}
                        traerUrl={traerUrl}
                        deshabilitado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                    />
                    <PanelAdjuntosDinamico 
                        titulo="Extra 1"
                        url={datosDelTramite?.extra_1URL}
                        editando={cambiarExtra1}
                        nuevoArchivo={nuevoExtra1}
                        setEditando={setCambiarExtra1}
                        setNuevoArchivo={setNuevoExtra1}
                        traerUrl={traerUrl}
                        deshabilitado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                    />

                </div>
                    <PanelEntrevista
                        status_actual_tramite={status_actual_tramite}
                        datosDelTramite={datosDelTramite}
                        linkEntrevista={linkEntrevista}
                        accederEntrevista={accederEntrevista}
                        IniciarCerrarEntrevista={IniciarCerrarEntrevista}
                        refrescar={refrescar}
                        usuario={usuario}
                    />

                </div>

            </div>
            <Botones
                sinCambiosPendientes={sinCambiosPendientes}
                touched={touched}
                inicioActualizacionTramite={inicioActualizacionTramite}
                actualizarTramite={actualizarTramite}
                cambiarStatus={cambiarStatus}
                finalizar={finalizar}
                puedeEditarse={puedeEditarse}
            />
        </div>
    );
};
